/* eslint-disable max-lines */
import bigDataLog from '@/utils/bigDataLog.js';
import Paper from '@/components/core/paper/Paper';
import { dictWithUrl } from '@/components/lots/api';
import config from './addPhysicalStorage.js';
import { AUDIT_STATUS } from '../../../../../constant/constant.js';
import BasicMessage from './BasicMessage.vue';
import AddQuaDialog from './AddQuaDialog.vue';
import DelQuaDialog from './DelQuaDialog.vue';
import RegisterUpload from '../../../../../components/upload/Index.vue';
import process from './Process.vue';
import otpAdvance from '../../../../../components/bulletFrame/otpAdvance/index.vue';
import mSelect from '../../../../../components/Select.vue';
import preview from '../../../../../components/viewAttachment.vue';
import SubWarehouse from './SubWarehouse.vue';
import ArtificialDialog from '../../keyData/detail/ArtificialDialog.vue';
import { savePhysicalImg, searchPhysicalDetail, searchQualification, uploadQualification,
    searchImages, MipExamine, delPhysicalStorage,savePhysicalBasicInfo } from '../../../../../api/addPhysicalStorage.js';
import { mapGetters } from 'vuex';
import { form, qualificationForm, imagesList, WH_AUDIT_STATUS } from './initData.js';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
// const TWO = 2;
const TWO_HUNDRED = 200;
const FIVE_HUNDRED = 500;
export default {
    name: 'addPhysicalStorage',
    components: { BasicMessage, AddQuaDialog, DelQuaDialog, RegisterUpload, otpAdvance, mSelect, Paper, preview, process, SubWarehouse,ArtificialDialog },
    data() {
        return {
            attachmentList: [], // 预览图片列表
            allAttachmentList: [], // 资质附件图片列表
            whCode: '',
            activeName: 'basic-message',
            config,
            tableData: [], // 资质附件表格数据
            uploadDisplayType: 'icon',
            attachmentShow: false,
            dialogVisible: false, // 资质附件弹窗
            DialogTitle: '新增', // 资质附件弹窗标题
            formLabelWidth: '140px', // 资质附件弹窗表单label宽度
            // addType: 'add',
            flag: {}, // 资质附件弹窗标题上传附件回传
            saveBtnShow: true, // 外层保存按钮显示
            mipShow: true, // MIP流程时显示控制
            rowData: {}, // 附件预览对象
            // form_: {}, // 基本信息表单初始化值备份
            delRowData: [], // 资质附件删除项
            whNameMip: '', // MIP流程使用的仓库名称
            mipNum: this.$store.state.mipNum, // 控制是否自动跳转MIP审批
            // text: `1、有产权证：产权证街道(简称)+产权人(简称);2、土地租赁合同：租赁合同街道(简称)+土地租赁方(简称);,3、命名重复添加后缀二/三/四等区分,如伦教韦德利二仓。`, // 仓库名称说明文本
            detailData: JSON.parse(JSON.stringify(form)), // 详情信息
            whStatus: '0', // 仓库状态 默认 0 草稿
            qualificationForm: JSON.parse(JSON.stringify(qualificationForm)), // 资质附件表单
            imagesList: JSON.parse(JSON.stringify(imagesList)), // 图片保存时传参
            // rules: rules, // 基本信息表单规则
            qualificationRules: { // 资质附件表单规则
                qualificationName: [{ required: true, message: '请输入资质名称', trigger: ['blur', 'change'] }],
                certificateEndDate: [{ required: false, message: '请选择终止日期', trigger: ['blur', 'change'] }],
                fileName: [{ required: true, message: '请上传附件' }]
            },
            // isUserRights: false, // 按钮权限-仓库详情展示
            // isFormItemFlag: false, // 加权表单项显示控制
            isUserDisabled: false, // 仓库状态合格，且创建人是当前登录账号
            // userCode: '', // 当前登录账号
            isPrivilege: false, // 特权修改
            attachmentTypeOptions: [], // 资质附件删除弹窗-产权分类选择项
            dictData: {},
            currentAttachment: null,
            pickerOptions: {
                disabledDate(time) {
                    // 选择今天以及今天之后的日期
                    return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择
                },
            },
            changeFlag: false, // 变更 状态
        };
    },
    created() {
        // this.isUserRights = this.btnPermissions.indexOf('04000301') !== -1 || this.isUserRights;
        // this.userCode = this.$store.state.user.userCode;
    },
    mounted() {
        // this.form_ = JSON.parse(JSON.stringify(this.form));
        dictWithUrl('SRM_PROPERTY_RIGHT_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data;
                if (this.whCode) {
                    this.searchQualification();
                }
            }
        })
        this.getPhysicalDetail();
        this.getImgs();
        bigDataLog.sendDetailMessageByKey('bigData-btn-page');
        bigDataLog.sendDetailMessageByKey('bigData-btn-baseMsg');
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'btnPermissions']),
        queryWhCode() {
            return this.$route.query.whCode;
        },
        // 资质附件 删除按钮: 无数据，或非特权且审批状态是审批中、审批通过时置灰
        qualiDelDisabled() {
            return !this.attachmentTypeOptions.length || (!this.isPrivilege && ([WH_AUDIT_STATUS.APPROVALING, WH_AUDIT_STATUS.APPROVED].includes(this.detailData.approveStatus)));
        },
        artificialState() {
            let flag = false
            const baseForm = this.$refs.basMsgRef.form
            // 物理仓仓库状态  whStatus  0：停用、2：新增
            // 审批状态 approveStatus  3：审批通过、5：废弃
            // 产权属性 propertyType  2：安得租赁
            // 物理仓状态=停用、新增，审批状态=审批通过、作废、空 、未提交审批,产权属性等于安得租赁 这个条件是满足mip提交条件，则需要审批弹窗，其他不需要
            if (
                ['0', '2'].includes(baseForm.whStatus)
                && ['','0','3', '5'].includes(baseForm.approveStatus)
                && baseForm.propertyType === '2'
            ) {
                flag = true
            }
            console.log('artificialState', flag, baseForm.whStatus, baseForm.approveStatus, baseForm.propertyType)
            return flag
        },
        // 变更状态: 审批状态=审批通过，仓库状态=合格，支持变更，其他条件【变更】按钮置灰
        changeDisabled() {
            // 物理仓仓库状态  whStatus  0：停用、2：新增、1：合格
            // / 审批状态 approveStatus  3：审批通过、5：废弃
            const {whStatus, approveStatus} = this.detailData
            let flag = true
            if (whStatus === '1' && approveStatus === '3') {
                flag = false
            }
            return flag;
        },
    },
    methods: {
        setSearchPhysicalDetail(res) {
            if (res && +res.code === 0) {
                this.$refs.basMsgRef.setFormData(res.data)
                this.detailData = res.data
                this.whNameMip = res.data.whName
                this.whStatus = res.data.whStatus
            }
        },
        getSearchPhysicalDetail() {
            this.activeName = 'basic-message';
            this.isPrivilege = false;
            if (this.queryWhCode) {
                this.whCode = this.queryWhCode;
                if (this.$route.query.iflow) {
                    this.saveBtnShow = false;
                    this.mipShow = false;
                }
                return searchPhysicalDetail(this.whCode)
            }
        },
        // 删除流程后，刷新流程信息
        onDeleteProcess() {
            searchPhysicalDetail(this.whCode).then(res => {
                if (res && +res.code === 0) {
                    const baseForm = this.$refs.basMsgRef.form
                    baseForm.approveStatus = res && res.data && res.data.approveStatus
                }
            });
        },
        handleSearchPhysicalDetail() {
            // this.$refs.form.resetFields();
            this.activeName = 'basic-message';
            this.isPrivilege = false;
            if (this.queryWhCode) {
                this.whCode = this.queryWhCode;
                if (this.$route.query.iflow) {
                    this.saveBtnShow = false;
                    this.mipShow = false;
                }
                searchPhysicalDetail(this.whCode).then(res => {
                    if (res && +res.code === 0) {
                        this.$refs.basMsgRef.setFormData(res.data);
                        // this.form = res.data;
                        // this.setVisible(this.form.factoryFlag, 'factoryFlag');
                        this.detailData = res.data;
                        this.whNameMip = res.data.whName;
                        this.whStatus = res.data.whStatus;
                        // // 当前登录账号是该仓的创建账号，或有仓库详情展示的按钮权限
                        // this.isFormItemFlag = this.userCode === this.form.createUserCode || this.isUserRights;
                        this.setUploadDisabled();
                        if (this.$route.query.iflow && this.$store.state.mipNum === 1) {
                            this.MipApproval();
                            this.$store.commit('setMipNum', this.mipNum + 1);
                        }
                    }
                });
            } else {
                this.addPhysicalStorage();
            }
        },
        getPhysicalDetail() {
            // this.$refs.form.resetFields();
            this.activeName = 'basic-message';
            this.isPrivilege = false;
            if (this.queryWhCode) {
                this.whCode = this.queryWhCode;
                if (this.$route.query.iflow) {
                    this.saveBtnShow = false;
                    this.mipShow = false;
                }
                searchPhysicalDetail(this.whCode).then(res => {
                    if (res && +res.code === 0) {
                        this.$nextTick(() => {
                            this.$refs.basMsgRef.setFormData(res.data);
                        })
                        // this.form = res.data;
                        // this.setVisible(this.form.factoryFlag, 'factoryFlag');
                        this.detailData = res.data;
                        this.whNameMip = res.data.whName;
                        this.whStatus = res.data.whStatus;
                        // // 当前登录账号是该仓的创建账号，或有仓库详情展示的按钮权限
                        // this.isFormItemFlag = this.userCode === this.form.createUserCode || this.isUserRights;
                        if (this.$route.query.iflow && this.$store.state.mipNum === 1) {
                            this.MipApproval();
                            this.$store.commit('setMipNum', this.mipNum + 1);
                        }
                    }
                });
            } else {
                this.addPhysicalStorage();
            }
        },
        // 返回
        toPhysicalStorage() {
            this.$router.push({
                path: '/physicalStorage'
            });
        },
        // 新增
        addPhysicalStorage() {
            // this.$refs.form.resetFields();
            this.activeName = 'basic-message';
            this.saveBtnShow = true;
            // this.isFormItemFlag = true;
            this.whCode = '';
            this.isPrivilege = false;
            this.imagesList = JSON.parse(JSON.stringify(imagesList));
            this.tableData = []
            // this.form = JSON.parse(JSON.stringify(this.form_));
            // this.config.list.forEach((item, index) => {
            //     if (index > TWO) {
            //         item.disabled = false;
            //     }
            // });
            this.$refs.basMsgRef.initFormData();
            this.config.wareHousePhotos.forEach(item => {
                item.imageUrl = '';
                item.disabled = false;
            });
        },
        // 校验附件
        verifyAttachments() {
            let attachmentName = '';
            if (Array.isArray(this.tableData) && this.tableData.length < 1) {
                attachmentName = '资质附件'
            } else if (Array.isArray(this.tableData) && this.tableData.length > 0) {
                for (const item of this.tableData) {
                    if (!item.fileUrl) {
                        attachmentName = `资质附件-${item.qualificationName}`
                        break;
                    }
                }
            }
            return attachmentName
        },
        // 设置保存附件参数
        setAttachmentsData() {
            let attachmentNameList = [];
            if (Array.isArray(this.tableData) && this.tableData.length > 0) {
                const dataList = []
                if (!this.whCode) {
                    for (const item of this.tableData) {
                        const row = {
                            // id: item.qualificationForm.id,
                            whCode: item.qualificationForm.whCode,
                            qualificationName: item.qualificationForm.qualificationName,
                            certificateBeginDate: item.qualificationForm.certificateBeginDate,
                            certificateEndDate: item.qualificationForm.certificateEndDate,
                            fileName: item.qualificationForm.fileName,
                            fileUrl: item.qualificationForm.fileUrl,
                            fileId: item.qualificationForm.fileId,
                            qualificationTypeCode: item.qualificationForm.qualificationTypeCode,
                            qualificationType: item.qualificationForm.qualificationType,
                            certificateNo: item.qualificationForm.certificateNo,
                            attachmentType: item.attachmentType,
                            defautQualificationFlag: item.defautQualificationFlag,
                        }
                        dataList.push(row)
                    }
                } else {
                    for (const item of this.tableData) {
                        const row = {
                            id: item.id,
                            whCode: this.whCode,
                            qualificationName: item.qualificationName,
                            certificateBeginDate: item.certificateBeginDate,
                            certificateEndDate: item.certificateEndDate,
                            fileName: item.fileName,
                            fileUrl: item.fileUrl,
                            fileId: item.fileId,
                            qualificationTypeCode: item.qualificationTypeCode,
                            qualificationType: item.qualificationType,
                            certificateNo: item.certificateNo,
                            attachmentType: item.attachmentType,
                            defautQualificationFlag: item.defautQualificationFlag,
                        }
                        dataList.push(row)
                    }

                }
                attachmentNameList = dataList
            }
            return attachmentNameList
        },
        // 设置图片页签参数
        setImgList() {
            let imgList = [];
            if (!this.whCode && Array.isArray(this.config.wareHousePhotos)) {
                const dataList = []
                for (let i = 0; i < this.config.wareHousePhotos.length; i++) {
                    const item = this.config.wareHousePhotos[i];
                    if (item.rowData) {
                        const row = {
                            fileId: item.rowData && item.rowData.id,
                            fileName: item.rowData.localFileName,
                            fileUrl: item.rowData.downUrl,
                            index: i,
                            qualificationName: item.label,
                            warehouseImgName: item.label,
                        }
                        dataList.push(row)
                    }
                }
                imgList = dataList
            } else {
                const dataList = []
                for (let i = 0; i < this.imagesList.qualificationInfos.length; i++) {
                    const item = this.imagesList.qualificationInfos[i];
                    const row = {
                        id: item.id,
                        fileId: item.fileId,
                        fileName: item.fileName,
                        fileUrl: item.fileUrl,
                        index: i,
                        qualificationName: item.qualificationName,
                        warehouseImgName: item.qualificationName,
                    }
                    dataList.push(row)
                }
                imgList = dataList
            }
            return imgList
        },
        // 校验图片
        verifyImage() {
            let imgName = '';
            if (Array.isArray(this.config.wareHousePhotos)) {
                for (const item of this.config.wareHousePhotos) {
                    if (item.required && !item.imageUrl) {
                        imgName = `必传图片-${item.label}`
                        break;
                    }
                }
            }
            return imgName
        },
        // 保存
        savePhysicalStorage() {
            const baseForm = this.$refs.basMsgRef.form
            // 产权属性等于租赁
            if (baseForm.propertyType === '2') {
                this.leaseSave();
                return false
            }
            if (this.activeName === 'basic-message') {
                // this.$refs['form'].validate((valid) => {
                //     if (valid) {
                //         if (+this.form.usableArea > +this.form.whSquare) {
                //             this.$message.warning('实用面积不能大于仓库建筑面积!');
                //             return false;
                //         }
                //         if (this.form.imagesList || this.form.qualificationInfos) {
                //             delete this.form.imagesList;
                //             delete this.form.qualificationInfos;
                //         }
                //         if (this.whCode) {
                //             this.form.whCode = this.whCode;
                //         } else {
                //             delete this.form.whCode;
                //         }
                //         const params = { ...this.form };
                //         savePhysicalBasicInfo(params).then(res => {
                //             if (res && +res.code === 0) {
                //                 this.whCode = res.data.whCode;
                //                 this.whNameMip = res.data.data[0].whName;
                //                 this.$message.success('基本信息保存成功');
                //                 setTimeout(() => {
                //                     this.$router.push({
                //                         path: '/addPhysicalStorage',
                //                         name: 'addPhysicalStorage',
                //                         query: {
                //                             whCode: this.whCode
                //                         }
                //                     });
                //                 }, FIVE_HUNDRED);
                //             }
                //         });
                //     }
                // });
                this.$refs.basMsgRef.saveFormData();
            }
        },
        leaseSave() {
            const basicFlag = this.$refs.basMsgRef.saveValidate();
            // const attachmentName = this.verifyAttachments()
            // const imgName = this.verifyImage()
            if (basicFlag !== true) {
                this.$message.warning(basicFlag);
                return false
            }
            // if (attachmentName) {
            //     this.$message.warning(`请上传${attachmentName}`);
            //     return false
            // }
            // if (imgName) {
            //     this.$message.warning(`请上传${imgName}`);
            //     return false
            // }
            const saveData = this.$refs.basMsgRef.saveData();
            const attachmentsData = this.setAttachmentsData();
            const imgList = this.setImgList();
            const params = {
                ...saveData,
                qualificationInfos: attachmentsData,
                tenantCode: this.currentTenant.tenantCode,
                imagesList: imgList,
            }
            // console.log('params44', params);
            // return
            savePhysicalBasicInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.whCode = res.data.whCode;
                    this.whNameMip = res.data.data[0].whName;
                    this.$message.success('保存成功');
                    this.getPhysicalDetail();
                    setTimeout(() => {
                        this.$router.push({
                            path: '/addPhysicalStorage',
                            name: 'addPhysicalStorage',
                            query: {
                                whCode: this.whCode,
                            },
                        });
                    }, FIVE_HUNDRED);
                }
            });
        },
        // 必传图片校验
        validRequiredImg() {
            let valid = true;
            const imgs = [];
            // 编辑保存时，校验必传图片
            if (this.whCode) {
                this.config.wareHousePhotos.forEach(item => {
                    if (['wxfkt', 'yqzpmt'].includes(item.prop) && !item.imageUrl) {
                        valid = false;
                        imgs.push(item.label);
                    }
                });
                if (!valid) {
                    this.$message.warning(`图片信息内，请上传${imgs.join('、')}`);
                }
            }
            return valid;
        },
        // 租仓方案弹窗确定
        handleSubmit(type, params) {
            // 新增
            if (type === 'submit') {
                this.mipFun('submitArtificia', params.data)
            }
            // 变更
            else if (type === 'change') {
                this.onChangeApplySave(params.data)
            }
        },

        // MIP审批
        async MipApproval() {
            const processTableData = this.$refs.processRef.totalData
            const {iflowWhType, mbpmFlowId} = this.$route.query
            // 流程信息第一条数据时草稿或者撤回状态时，直接跳转审批页面
            if (
                processTableData.length && iflowWhType !== 'whChange' &&
                [AUDIT_STATUS.DRAFT, AUDIT_STATUS.WITHDRAW].includes(processTableData[0].auditStatus)
            ) {
                const query = {
                    processId: processTableData[0].auditMipId,
                    // formInstanceId: res.data.formId,
                    path: '/physicalStorage'
                }
                this.$router.push({
                    name: 'mipIframe',
                    query,
                })
                return false
            } else if (iflowWhType === 'whChange') {
                const query = {
                    processId: mbpmFlowId,
                    // formInstanceId: res.data.formId,
                    path: '/physicalStorage?iflowWhType=whChange',
                }
                return this.$router.push({
                    name: 'mipIframe',
                    query,
                })
            }
            if (!this.validRequiredImg()) {
                return false;
            }
            if (!this.validAttachmentName()) {
                return false;
            }
            const res = await this.getSearchPhysicalDetail()
            this.setSearchPhysicalDetail(res)
            if (this.artificialState) {
                this.$refs.artificialDialog.handleVisible(true);
                return false;
            }
            this.mipFun()
        },
        // 校验资质附件
        validAttachmentName() {
            const attachmentName = this.verifyAttachments()
            const baseForm = this.$refs.basMsgRef.form
            const specialApproveFlag = baseForm.specialApproveFlag
            const propertyType = baseForm.propertyType

            // 校验资质附件是否必填判断： 1、产权属性是安得租赁是要必填的； 2、产权属性不是安得租赁，是特批资质非必填，不是特批资质必填
            // 产权属性 propertyType  2：安得租赁
            // 是特批 specialApproveFlag  1：是特批，0：不是特批
            if (attachmentName && this.whCode && propertyType === '2') {
                this.$message.warning(`请上传${attachmentName}`);
                return false
            }
            if (attachmentName && this.whCode && propertyType !== '2' && specialApproveFlag ==='0') {
                this.$message.warning(`请上传${attachmentName}`)
                return false
            }
            return true
        },
        mipFun(type, approvalData) {
            const params = {
                tenantCode: this.currentTenant.tenantCode,
                appCode: this.applicationCode,
                fdTemplateId: '1202209634388434944',
                fdTemplateCode: 'srm_warehouse',
                loginName: this.$store.getters.user.userCode,
                formParam: {
                    subject: '供应商注册-物理仓-审批-' + this.whNameMip,
                    formInstanceId: this.whCode,
                    fdUrl: location.origin + location.pathname + `#/addPhysicalStorage?whCode=` + this.whCode + '&iflow=' + this.mipNum
                }
            };
            if (type === 'submitArtificia') {
                params.whBizType = approvalData.whBizType;
                params.whMipBizInfo = approvalData.whMipBizInfo;
            }
            MipExamine(params).then(res => {
                if (res && +res.code === 0) {
                    this.$store.commit('setWhCode', this.whCode);
                    const query = {
                        processId: res.data.fdId,
                        formInstanceId: res.data.formId,
                        path: '/physicalStorage'
                    }
                    this.$router.push({
                        name: 'mipIframe',
                        query,
                    });
                }
            });

        },
        handleClick(tab, event) {
            this.activeName = tab.name;
            if (this.activeName === '2') {
                if (this.whCode) {
                    this.searchQualification();
                }
            }
            const bigDatakeys = {
                'basic-message': 'baseMsg',
                'sub-warehouse': 'warehouse',
                '2': 'attachment',
                '3': 'photo',
                '4': 'process'
            };
            bigDataLog.sendDetailMessageByKey('bigData-btn-' + bigDatakeys[tab.name]);
        },
        // 获取图片页签数据
        getImgs() {
            if (!this.queryWhCode) { return false; }
            searchImages(this.queryWhCode).then(res => {
                if (res && +res.code === 0) {
                    this.imagesList = res.data;
                    if (res.data.qualificationInfos && res.data.qualificationInfos.length) {
                        const arr = [];
                        this.imagesList.qualificationInfos.forEach(item => {
                            arr.push(item.warehouseImgName);
                        });
                        this.imagesList.qualificationInfos.forEach(item => {
                            this.config.wareHousePhotos.forEach(val => {
                                if (arr.indexOf(val.label) !== -1 && val.label === item.warehouseImgName) {
                                    val.imageUrl = item.fileUrl;
                                } else if (arr.indexOf(val.label) === -1) {
                                    val.imageUrl = '';
                                }
                            });
                        });
                    } else {
                        this.config.wareHousePhotos.forEach(val => {
                            val.imageUrl = '';
                        });
                    }
                }
            });
        },
        // 特权修改
        privilegeAlter() {
            this.isPrivilege = true;
            this.saveBtnShow = true;
            if (!['basic-message', 'sub-warehouse', '3'].includes(this.activeName)) {
                this.activeName = 'basic-message';
            }
            this.$refs.basMsgRef.clearDisabled();
            this.config.wareHousePhotos.forEach(item => {
                if (['wxfkt', 'yqzpmt'].includes(item.prop)) {
                    item.disabled = false;
                }
            });
        },
        /** 删除物理仓 **/
        deletePhysicalStorage() {
            const whCode = this.whCode;
            if (!whCode) {
                this.$message.warning('当前没有物理仓编码！');
                return;
            }
            this.$confirm('是否确定删除当前物理仓?', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delPhysicalStorage(whCode).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('删除成功');
                        this.whCode = '';
                        // this.form = JSON.parse(JSON.stringify(form));
                        this.qualificationForm = JSON.parse(JSON.stringify(qualificationForm));
                        this.imagesList = JSON.parse(JSON.stringify(imagesList));
                        // this.$refs['form'].resetFields();
                        this.$refs.basMsgRef.clearDisabled();
                    }
                });
            });
        },
        // getAdvanceValue(data) {
        //     if (data.ebplCode) {
        //         this.form.cityCode = data.ebplCode;
        //         this.form.cityName = data.ebplNameCn;
        //     } else if (data.eblcCode) {
        //         Object.keys(data).forEach(el => {
        //             this.form[el] = data[el];
        //         });
        //         this.form.addressCode = data.eblcCode;
        //         this.form.whAddress = data.eblcDetailAddress;
        //     } else if (data.companyCode) {
        //         this.form.companyName = data.companyNameCn;
        //     }
        //     this.form = { ...this.form, ...data };
        // },
        // 获取附件URL数组
        handleGetAllAttachmentList(list) {
            for (let i = 0; i < list.length; i++) {
                const node = list[i];
                this.allAttachmentList.push(node.fileUrl);
                if (node.children && node.children.length) {
                    this.handleGetAllAttachmentList(node.children);
                }
            }
        },
        // 新增资质（没有仓库编码）
        addSearchQualification(dataList) {
            if (!dataList) {
                dataList = []
            }
            this.tableData = dataList.map(item => {
                item.attachmentType_ = this.dictData.SRM_PROPERTY_RIGHT_TYPE[item.attachmentType];
                return item;
            });
            this.setAttachmentTypeOptions();
            this.allAttachmentList = [];
        },
        // 查询资质
        searchQualification() {
            searchQualification(this.whCode).then(res => {
                if (res && +res.code === 0) {
                    const that = this;
                    this.tableData = res.data.map(item => {
                        item.attachmentType_ = that.dictData.SRM_PROPERTY_RIGHT_TYPE[item.attachmentType];
                        return item;
                    });
                    this.setAttachmentTypeOptions();
                    this.allAttachmentList = [];
                    if (res.data && res.data.data) {
                        this.handleGetAllAttachmentList(res.data.data);
                        this.allAttachmentList = this.allAttachmentList.filter((item) => { if (item) return item; });
                    }
                }
            });
        },
        // 设置删除资质弹窗-产权分类选项
        setAttachmentTypeOptions() {
            const values = new Set();
            this.tableData.forEach(item => {
                if (item.attachmentType) {
                    values.add(item.attachmentType);
                }
            });
            const options = [];
            values.forEach(val => {
                options.push({
                    label: this.dictData.SRM_PROPERTY_RIGHT_TYPE[val],
                    value: val
                });
            });
            this.attachmentTypeOptions = options;
        },
        // // 新增资质
        // addQualification() {
        //     this.addType = 'add';
        //     this.DialogTitle = '新增';
        //     this.qualificationForm.whCode = this.whCode;
        //     this.qualificationForm.qualificationType = '仓库资质';
        //     this.qualificationForm.qualificationTypeCode = this.whCode;
        //     this.dialogVisible = true;
        // },
        // 新增资质
        handleAdd() {
            this.$refs.addQuaRef.open();
        },
        // 上传资质
        uploadDialog(data) {
            // this.addType = 'upload';
            this.DialogTitle = '上传';
            this.qualificationForm.qualificationType = data.qualificationType;
            this.qualificationForm.qualificationTypeCode = data.qualificationTypeCode;
            this.qualificationForm.whCode = this.whCode;
            this.qualificationForm.certificateBeginDate = data.certificateBeginDate;
            this.qualificationForm.qualificationName = data.qualificationName;
            this.qualificationForm.certificateNo = data.certificateNo;
            if (data.certificateEndDate) {
                this.qualificationForm.certificateEndDate = data.certificateEndDate;
            }
            this.flag = {
                id: data.id,
                qualificationType: data.qualificationType,
                qualificationTypeCode: data.qualificationTypeCode,
                qualificationName: data.qualificationName
            };
            this.currentAttachment = data;
            this.dialogVisible = true;
        },
        // // 删除资质
        // delQualification() {
        //     if (this.delRowData.length) {
        //         if (this.delRowData.indexOf('FNode') !== -1) {
        //             this.$message.warning('有父级被选中了');
        //         } else if (this.delRowData.indexOf('UnDefault') !== -1) {
        //             this.$message.warning('有默认资质被选中了');
        //         } else {
        //             this.$confirm('确定要删除选中的资质吗？', '删除提示', {
        //                 confirmButtonText: '确定',
        //                 cancelButtonText: '取消',
        //                 type: 'warning'
        //             }).then(() => {
        //                 delQualification(this.delRowData).then(res => {
        //                     if (res && +res.code === 0) {
        //                         this.$message.success('删除成功');
        //                         this.searchQualification();
        //                     }
        //                 });
        //             });
        //         }
        //     } else {
        //         this.$message.warning('请选择要删除的资质');
        //     }
        // },
        // 删除资质
        handleDel() {
            this.$refs.delQuaRef.open();
        },
        // 资质复选框选择
        selectionChange(row) {
            const FNode = [];
            const arr = [];
            row.forEach(item => {
                if (item.qualificationName) {
                    FNode.push(item);
                } else {
                    arr.push('FNode');
                }
            });
            FNode.forEach(item => {
                if (item.defautQualificationFlag === '1') {
                    arr.push(item.id);
                } else {
                    arr.push('UnDefault');
                }
            });
            this.delRowData = arr;
        },
        // 图片上传
        uploadSuccessImg(data,item) {
            if (+data.data.code === 0) {
                if (this.whCode) {
                    this.config.wareHousePhotos[data.flag.index].imageUrl = data.data.data.downUrl;
                    data.flag.fileName = data.data.data.localFileName;
                    data.flag.fileUrl = data.data.data.downUrl;
                    data.flag.fileId = data.data.data.id;
                    this.imagesList.qualificationInfos = [];
                    this.imagesList.qualificationInfos.push(data.flag);
                    this.saveSingleImage(data.flag);
                } else {
                    item.rowData = data.data.data,
                    item.fileName = data.data.data.localFileName;
                    item.fileUrl = data.data.data.fileUrl;
                    item.fileId = data.data.data.fileId;
                    item.imageUrl = data.data.data.downUrl;
                    // this.$message.warning('保存失败，当前没有仓库编码，请维护并保存基本信息');
                }
            }
        },
        /** 每次上传完图片就执行保存当前图片 **/
        saveSingleImage(item) {
            this.imagesList.whCode = this.whCode;
            // 判断新增还是更新
            if (this.detailData.imagesList && this.detailData.imagesList.qualificationInfos) {
                const index = this.detailData.imagesList.qualificationInfos.findIndex((e) => e.qualificationName === item.qualificationName);
                if (index !== -1) {
                    this.imagesList.qualificationInfos[0].id = this.detailData.imagesList.qualificationInfos[index].id;
                }
            }
            savePhysicalImg(this.imagesList).then(res => {
                this.$message.success('上传成功');
                this.getImgs()
            });
        },
        // propsChange(value, prop) {
        //     const data = {};
        //     data[prop] = value;
        //     Object.assign(this.form, data);
        //     this.setVisible(value, prop);
        // },
        // setVisible(value, prop) {
        //     if (prop === 'factoryFlag') {
        //         const fIndex = config.list.findIndex(item => item.prop === 'factorySign');
        //         if (+value === +SRM_YES) {
        //             config.list[fIndex].hidenInBase = false;
        //         } else {
        //             config.list[fIndex].hidenInBase = true;
        //             this.form.factorySign = '';
        //         }
        //     }
        // },
        // 关闭新增资质弹框
        handleClose() {
            this.qualificationForm = {
                id: '',
                whCode: this.whCode,
                qualificationName: '',
                certificateBeginDate: '',
                certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                fileId: '',
                qualificationTypeCode: '',
                qualificationType: '',
                certificateNo: ''
            };
            this.dialogVisible = false;
            this.$refs['qualificationForm'].resetFields();
        },
        // 上传附件的回调
        callback(data) {
            if (data.data.code === '0') {
                this.rowData = data.data.data;
                this.attachmentList = [];
                this.rowData.updateTime = data.data.timestamp;
                this.qualificationForm.fileName = data.data.data.localFileName;
                this.qualificationForm.fileUrl = data.data.data.downUrl;
                this.qualificationForm.fileId = data.data.data.id;
                this.qualificationForm.id = data.flag.id;

                if (this.currentAttachment) {
                    this.currentAttachment.rowData = this.rowData;
                    this.currentAttachment.qualificationForm = cloneDeep(this.qualificationForm)
                }
                this.$message.success('附件上传成功');
            } else {
                this.$message.error('上传失败');
            }
        },
        // 图片页签-点击图片预览
        handleShowPic(url) {
            if (url) {
                const imagesReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/;
                if (imagesReg.test(url)) {
                    this.rowData.downUrl = url;
                    this.attachmentShow = true;
                } else {
                    this.$message.warning('该文件为非图片格式文件');
                }
            }
        },
        // 新增附件弹框-附件预览
        previewBtn() {
            if (this.qualificationForm.fileName) {
                this.attachmentShow = true;
            } else {
                this.$message.warning('请上传附件');
            }
        },
        // 新增附件弹框-确定
        save() {
            if (this.qualificationForm.whCode) {
                this.uploadByWhCode()
            } else {

                this.$refs['qualificationForm'].validate((valid) => {
                    if (valid) {
                        const qualificationFormClone = cloneDeep(this.qualificationForm)
                        this.currentAttachment.qualificationForm = qualificationFormClone
                        this.currentAttachment.updateTime = this.currentAttachment.rowData.updateTime;
                        this.currentAttachment.fileName = qualificationFormClone.fileName;
                        this.currentAttachment.fileUrl = qualificationFormClone.fileUrl;
                        if (qualificationFormClone.certificateEndDate) {
                            this.currentAttachment.certificateEndDate = dayjs(
                                qualificationFormClone.certificateEndDate).format('YYYY-MM-DD 00:00:00')
                        } else {
                            this.currentAttachment.certificateEndDate = '';
                        }

                        this.currentAttachment.certificateNo = qualificationFormClone.certificateNo;
                        this.currentAttachment.defautQualificationFlagName = '是';
                        this.handleClose();
                        this.setAttachmentTypeOptions();
                        this.allAttachmentList = [];
                        // this.tableData = res.data.map(item => {
                        //     item.attachmentType_ = this.dictData.SRM_PROPERTY_RIGHT_TYPE[item.attachmentType];
                        //     return item;
                        // });
                        // this.searchQualification();
                    }
                })
            }
        },
        uploadByWhCode() {
            this.$refs['qualificationForm'].validate((valid) => {
                if (valid) {
                    uploadQualification(this.qualificationForm).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('上传成功');
                            this.handleClose();
                            this.searchQualification();
                        }
                    });
                    // if (this.addType === 'upload') {
                    //     uploadQualification(this.qualificationForm).then(res => {
                    //         if (res && +res.code === 0) {
                    //             this.$message.success('上传成功');
                    //             this.handleClose();
                    //             this.searchQualification();
                    //         }
                    //     });
                    // } else if (this.addType === 'add') {
                    //     addQualificationInfo(this.qualificationForm).then(res => {
                    //         if (res && +res.code === 0) {
                    //             this.$message.success('资质新增成功');
                    //             this.handleClose();
                    //             this.searchQualification();
                    //         }
                    //     });
                    // }
                } else {
                    return false;
                }
            });
        },
        // 资质附件-表格预览
        preview(data) {
            this.rowData.downUrl = data.fileUrl;
            this.rowData.fileId = data.fileId;
            this.rowData.fileName = data.fileName;
            this.attachmentList = this.allAttachmentList;
            this.attachmentShow = true;
        },
        // 附件下载更改名称
        getBlob(url, cb) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status === TWO_HUNDRED) {
                    cb(xhr.response);
                }
            };
            xhr.send();
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                const body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
        // 资质附件-表格下载附件
        handleDownload(data) {
            if (data.fileUrl) {
                if (data.fileUrl) {
                    const suffix = data.fileUrl.substring(data.fileUrl.lastIndexOf('.') + 1);
                    this.getBlob(data.fileUrl, blob => {
                        this.saveAs(blob, data.qualificationName + '.' + suffix);
                    });
                }
            }
        },
        // 图片页签-控制上传置灰
        setUploadDisabled() {
            this.config.wareHousePhotos.forEach(item => {
                if (['wxfkt', 'yqzpmt'].includes(item.prop)) {
                    // 审批状态是 审批中、审批通过 时置灰
                    item.disabled = [WH_AUDIT_STATUS.APPROVALING, WH_AUDIT_STATUS.APPROVED].includes(this.detailData.approveStatus);
                }
            });
        },
        // 图片页签-下载
        handleDownloadImg(data,item) {
            if (data.imageUrl) {
                const a = document.createElement('a');
                a.href = data.imageUrl;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                this.$message.warning('暂无图片');
            }
        },
        // 保存成功回调
        saveSuccess(data) {
            this.whCode = data.whCode;
            this.whNameMip = data.data[0].whName;
            this.getPhysicalDetail();
            setTimeout(() => {
                this.$router.push({
                    path: '/addPhysicalStorage',
                    name: 'addPhysicalStorage',
                    query: {
                        whCode: this.whCode
                    }
                });
            }, FIVE_HUNDRED);
        },
        setSaveBtnShow(flag) {
            this.saveBtnShow = flag;
        },
        onChange() {
            this.saveBtnShow = true
            this.changeFlag = true
            this.activeName = 'basic-message'
        },
        // 物流园变更申请打开租仓方案弹窗
        openArtificialDialog() {
            this.$refs.artificialDialog.handleVisible(true, { submitType: 'change' });
        },
        // 物流园详情->变更->弹窗保存->提交数据
        onChangeApplySave(data) {
            this.$refs.basMsgRef.onChangeApplySave(data)
        },
    },
    watch: {
        queryWhCode(val) {
            if (val) {
                this.handleSearchPhysicalDetail();
                if (this.whCode) {
                    this.searchQualification();
                }
                this.getImgs();
                this.$nextTick(() => {
                    this.$refs.subWarehouse.getList();
                });
            } else {
                this.addPhysicalStorage();
            }
        }
        // // 审批状态： 待审批 || 审批中 -> 全部置灰，保存按钮隐藏
        // 'form.approveStatus': {
        //     /**
        //      * SRM_PHY_WH_AUDIT_STATUS：物理仓审批状态
        //      * 【 1 == 草稿，2 == 审批中，3 == 审批通过，4 == 驳回，5 == 废弃 】
        //      */
        //     handler(nVal) {
        //         if ([WH_AUDIT_STATUS.APPROVALING, WH_AUDIT_STATUS.APPROVED].includes(nVal)) {
        //             config.list.forEach(item => {
        //                 item.disabled = true;
        //                 this.saveBtnShow = false;
        //             });
        //         } else {
        //             config.list.forEach((item, index) => {
        //                 if (index > TWO) {
        //                     item.disabled = false;
        //                 }
        //             });
        //         }
        //     },
        //     immediate: true
        // },
        // // 仓库状态：
        // // 新增(0) => 创建人特权人可显示修改加权菜单
        // // 合格(1) => 全部置灰，保存按钮隐藏，创建人特权人可显示加权菜单，仅特权人可以修改加权菜单;
        // // 停用(2) => 创建人特权人可显示修改加权菜单
        // 'form.whStatus': {
        //     /**
        //      * SRM_PHY_WH_AUDIT_STATUS：物理仓仓库状态
        //      * 【 0 == 新增， 1 == 合格，2 == 停用，3 == 启用，4 == 驳回，5 == 废弃，6 == 待审批 】
        //      */
        //     handler(nVal) {
        //         if (nVal === WH_STATUS.ADD) {
        //             this.isUserDisabled = false;
        //         } else if (nVal === WH_STATUS.QUALIFIED) {
        //             this.isUserDisabled = this.userCode === this.form.createUserCode;
        //             config.list.forEach(item => {
        //                 item.disabled = true;
        //                 // 仓库状态合格且审批通过后，创建人可以修改可用面积(m²)、单价(元/平方米)、联系人、联系电话 这四个字段，其他人使用特权修改
        //                 this.saveBtnShow = this.isUserDisabled && [WH_AUDIT_STATUS.APPROVED].includes(this.form.approveStatus);
        //             });
        //         } else {
        //             config.list.forEach((item, index) => {
        //                 if (index > TWO) {
        //                     item.disabled = false;
        //                 }
        //             });
        //             this.isUserDisabled = false;
        //         }
        //     },
        //     immediate: true
        // },
        // 'form.propertyType': {
        //     handler(nVal) {
        //         if (nVal !== '2' && nVal !== '5') {
        //             this.$set(this.rules.fireUnitArea[0], 'required', false);
        //         } else {
        //             this.$set(this.rules.fireUnitArea[0], 'required', true);
        //         }
        //     },
        //     immediate: true
        // }
    },
    activated() {
        this.saveBtnShow = true
        this.changeFlag = false
    },
};